export const createVariantActions = [
  'try-layout',
  'change-colors',
  'regenerate',
  'simplify',
  'add-content',
  'make-better',
  'fix-alignment',
  'convert-to-mobile',
  'convert-to-desktop',
] as const;

export type CreateVariantAction = (typeof createVariantActions)[number];

// NEVER delete a variant from here - this will mess up the `getMessageHistory` call.
// Instead, edit createVariantOptionGroups in CanvasCreateVariantDropdown.ts
export const createVariantPrompts: Record<
  CreateVariantAction,
  {label: string; prompt: string}
> = {
  simplify: {
    label: 'Simplify design',
    prompt: 'Make the design simpler and easier to understand',
  },
  'add-content': {
    label: 'Add more content',
    prompt: 'Add more content and details to the design',
  },
  'try-layout': {
    label: 'Try different layout',
    prompt: 'Try a different layout and reorganize the elements',
  },
  'change-colors': {
    label: 'Try new color scheme',
    prompt: 'Change the color scheme while keeping the layout',
  },
  'make-better': {
    label: 'Make it look better',
    prompt: 'Make the design look better and more polished',
  },
  'fix-alignment': {
    label: 'Fix alignment issues',
    prompt: 'Fix alignment and spacing issues in the design',
  },
  regenerate: {
    label: 'Regenerate from scratch',
    prompt:
      'Completely regenerate this design from scratch with a fresh approach',
  },
  'convert-to-mobile': {
    label: 'Convert to mobile',
    prompt:
      'Adapt this design to mobile screen dimensions (375px width). Keep the same content, visual style, and design language but reorganize the layout to work well on a mobile screen.',
  },
  'convert-to-desktop': {
    label: 'Convert to desktop',
    prompt:
      'Adapt this design to desktop screen dimensions (1440px width). Keep the same content, visual style, and design language but expand the layout to use the wider desktop screen effectively.',
  },
};
